import { useI18n } from 'vue-i18n'
import axios from 'axios'
import download from 'downloadjs'
import { notify } from '@kyvg/vue3-notification'
import { ref } from 'vue'

import { useAuthStore } from '@/stores/auth-store'
import { Receipt } from '@/types/pod'

/**
 * Use to download a receipts consignment notes.
 */
export function useDownloadConsignmentNotes() {
    const { t } = useI18n()
    const authStore = useAuthStore()
    const downloading = ref(false)

    return {
        downloading,
        downloadPDF: async function (receipt: Receipt) {
            try {
                downloading.value = true
                const response = await axios.get(
                    window.route('pod.company.receipts.download', {
                        company: authStore.companyId,
                        receipt,
                    }),
                    { responseType: 'blob' },
                )
                const contentDisposition = response.headers['content-disposition'] || ''
                const filename = contentDisposition.includes('attachment; filename=')
                    ? contentDisposition.replace('attachment; filename=', '').replace(/"/g, '')
                    : 'download.pdf'

                download(response.data, filename, 'application/pdf')

                notify({ type: 'success', text: t('pdfDownloadedSuccessfully') })
            } catch (error) {
                notify({ type: 'error', text: t('pdfDownloadFailed') })
            } finally {
                downloading.value = false
            }
        },
    }
}
